import React from 'react'
import Principal from '../../components/page-content/our-apps/principal'

export const Page = () => {
  return <Principal />
}
export default Page
